import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, object = user
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        // Skip /me call if there's no token and no cookie present (avoids
        // noisy 401s for anonymous public visitors).
        const hasToken = !!localStorage.getItem("ids_token");
        const hasCookie = typeof document !== "undefined" && document.cookie.includes("access_token=");
        if (!hasToken && !hasCookie) {
            setUser(false);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.token) localStorage.setItem("ids_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            // ignore
        }
        localStorage.removeItem("ids_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
